<template>
    <div class="actions-page" v-if="pageSetup != null">
        <div class="container">
            <div class="section-title">
                <h1>{{pageSetup.page_title}}</h1>
            </div>
            <!-- <actionsFilter></actionsFilter> -->
            <actionsItems></actionsItems>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import actionsItems from '@/components/actions/action-item.vue'
    import actionsFilter from '@/components/actions/actions-filter.vue'
    export default {
        name: 'actions--page',
        components: {
            actionsItems,
            actionsFilter
        },
        data () {
            return {
                title: 'Акции',
            }
        },
        computed: mapGetters({
            pageSetup: 'loadActionPage',
        }),
        methods: {
        },
        beforeRouteEnter (to, from, next) {
            store.dispatch('getActionPageData');
            if (store.state.actionsItems != null) {
                next(vm => {
                    vm.$parent.$refs.topProgress.done();
                    vm.$store.commit('removePageLoaderImg');
                });
            } else {
                store.dispatch('getActionsItems').then((response) => {
                    // console.log(response, 'how to by')
                    if (response) {
                        next(vm => {
                            vm.$parent.$refs.topProgress.done();
                            vm.$store.commit('removePageLoaderImg');
                        });
                    } else {
                        next(false, vm => vm.$parent.$refs.topProgress.fail());
                    }
                });
            }
        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
            document.body.dataset.page = 'actions';
        },
        created () {
            document.title = this.title;
        },
        mounted() {
        }
    }
</script>